<div class="payment-page">

    <div class="card">

        <div *ngIf="paid" class="success-icon">
            ✓
        </div>

        <div *ngIf="!paid" class="pending-icon">
            ⏳
        </div>

        <h1>
            {{ paid ? 'Pago realizado correctamente' : 'Procesando pago...' }}
        </h1>

        <p *ngIf="paid">
            Tu suscripción fue activada con éxito.
        </p>

        <p *ngIf="!paid">
            Estamos verificando tu pago.
        </p>

        <div class="plan-box">
            Plan {{ plan }}
        </div>

        <button *ngIf="paid" class="btn-primary" (click)="closePage()">
            Volver a Mediget
        </button>

    </div>

</div>